import BrandingConfig from './BrandingConfig';

export default BrandingConfig;
